import { createBrowserHistory, createMemoryHistory } from "history";
import { isServer } from "./functions";
const history = isServer
? createMemoryHistory({
		initialEntries: ['/'],
	})
: createBrowserHistory();
export default history;
